<template>
  <p class="main-title-container">
    <slot/>
  </p>
</template>

<script>
export default {
  name: "MainTitle"
}
</script>

<style scoped lang="scss">
.main-title-container {
  color: white;
  font-size: 14px;
  line-height: 18px;
}
</style>